import { render } from "./PostBody.vue?vue&type=template&id=0a94a4e6&scoped=true"
import script from "./PostBody.vue?vue&type=script&lang=js"
export * from "./PostBody.vue?vue&type=script&lang=js"

import "./PostBody.vue?vue&type=style&index=0&id=0a94a4e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a94a4e6"]])

export default __exports__